<template>
  <div id="app">
    <Header class="header" v-if="!isLogin"/>
    <router-view />
    <Footer class="footer" v-if="!isLogin"/>
  </div>
</template>

<script>
import Header from './components/header.vue';
import Footer from './components/footer.vue';

export default {
  name: 'app',
  components: {
    Header,
    Footer,
  },
  computed: {
    isLogin() {
      return this.$route.name === 'login';
    },
  },
};
</script>

<style src="./style/fonts.css"></style>
<style lang="stylus" src="./style/global.styl"></style>
<style lang="stylus" scoped>

  .footer
    height: 330px

</style>
